import { axiosWithAuth } from "helpers";

export const installationDetailsService = {
	getInstallationQueueDetails,
	installationComplete,
};

const API_URL = process.env.REACT_APP_API_URL;

function getInstallationQueueDetails(applicationId: string) {
	const options = {
		method: "GET",
		url: `${API_URL}/api/applications/installation_queue/${applicationId}/details`,
	};

	return axiosWithAuth(options);
}

function installationComplete(applicationId: string, option: string) {
	const options = {
		method: "POST",
		url: `${API_URL}/api/applications/installation_queue/${applicationId}/complete`,
		data: {
			installation_outcome: option,
		},
	};
	return axiosWithAuth(options);
}
